export default __webpack_public_path__ + "static/B0110-b3fcd699b08ff8fe99f875b9e421dbb4.png";